import { ShieldCheck, Clock, BadgeCheck, Calculator } from "lucide-react";
import { FadeIn } from "./Reveal";

const ITEMS = [
    { icon: ShieldCheck, title: "Solidnie", desc: "Prace wykonane z dbałością o każdy detal — bez pośpiechu i fuszerki." },
    { icon: Clock, title: "Terminowo", desc: "Ustalony harmonogram to u nas świętość. Kończymy, kiedy obiecujemy." },
    { icon: BadgeCheck, title: "Gwarancja jakości", desc: "Na wszystkie wykonane prace udzielamy gwarancji i pewnego odbioru." },
    { icon: Calculator, title: "Darmowa wycena", desc: "Przyjedziemy, zmierzymy i wycenimy — całkowicie za darmo i bez zobowiązań." },
];

export default function Benefits() {
    return (
        <section id="zalety" className="bg-white py-24 md:py-28">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-6 sm:grid-cols-2 md:px-12 lg:grid-cols-4">
                {ITEMS.map((item, i) => (
                    <FadeIn key={item.title} delay={i * 0.08}>
                        <div
                            data-testid={`benefit-${i}`}
                            className="group h-full rounded-3xl border border-ink/8 bg-white p-8 shadow-sm transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/50 hover:shadow-[0_24px_50px_-20px_rgba(10,10,10,0.15)]"
                        >
                            <div className="mb-6 inline-flex rounded-2xl bg-gold p-3.5 text-ink transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-105">
                                <item.icon className="h-6 w-6" strokeWidth={2} />
                            </div>
                            <h3 className="font-display text-xl font-bold tracking-tight text-ink">{item.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-ink/55">{item.desc}</p>
                        </div>
                    </FadeIn>
                ))}
            </div>
        </section>
    );
}
